module.exports = __webpack_public_path__ + "static/media/3en.9529e19f.jpg";